<div class="tv-startup" *ngIf="showIntro">
  <div class="scanlines"></div>
  <div class="text">
    <div class="logo">LOFI RADIO</div>
    <div class="author">by Emanuel V. Sacoman</div>
  </div>
</div>
